// extracted by mini-css-extract-plugin
module.exports = {"HeaderCircle":"HeaderCircle-module--HeaderCircle--6NK49","pingPong":"HeaderCircle-module--pingPong--31esc"};